import { Injectable } from '@angular/core';
import { Role } from 'src/app/constants/role';
import { User } from 'src/app/models/user';

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  roles?: number[];
}

const MENUITEMS = [
  { state: 'dashboard', name: 'Dashboard', type: 'link', icon: 'av_timer' },
  { state: 'profile', type: 'link', name: 'Profile', icon: 'crop_7_5' },
  { state: 'profile-menu', type: 'link', name: 'Pemutakhiran Data', icon: 'view_comfy' },
  { state: 'notification', type: 'link', name: 'Notifikasi', icon: 'view_list' },
  { state: 'user', type: 'link', name: 'Data Pegawai', icon: 'view_headline', roles: [Role.SUPERADMIN, Role.ADMIN_KEPEGAWAIAN], },
  { state: 'alarm-pegawai', type: 'link', name: 'Alarm Pegawai', icon: 'tab', roles: [Role.SUPERADMIN, Role.ADMIN_KEPEGAWAIAN], },
  { state: 'formasi', type: 'link', name: 'Peta Jabatan', icon: 'web', roles: [Role.SUPERADMIN, Role.ADMIN_KEPEGAWAIAN], },
  { state: 'cuti', type: 'link', name: 'Cuti', icon: 'vertical_align_center' },
  { state: 'approval-cuti', type: 'link', name: 'Approval Cuti', icon: 'vignette', roles: [Role.SUPERADMIN, Role.ADMIN_CUTI], },
  { state: '404', type: 'link', name: 'Kehadiran', icon: 'voicemail', roles: [Role.SUPERADMIN, Role.ADMIN_KEPEGAWAIAN], },
  {
    state: 'regulasi',
    type: 'link',
    name: 'Regulasi',
    icon: 'border_horizontal'
  },
  {
    state: 'https://persuratan.kemdikbud.go.id/',
    type: 'external-link',
    name: 'Sistem Naskah Dinas Elektronik',
    icon: 'blur_circular'
  },
  {
    state: 'http://skp.sdm.kemdikbud.go.id/skp/site/login.jsp',
    type: 'external-link',
    name: 'Sistem SKP Elektronik',
    icon: 'assignment_turned_in'
  },
  { state: 'http://kehadiran.sdm.kemdikbud.go.id/', type: 'external-link', name: 'Sistem Informasi Kehadiran', icon: 'assistant' },
];

@Injectable()
export class MenuItems {
  getMenuitem(user: User): Menu[] {
    return MENUITEMS.filter((menu) => !menu.roles || menu.roles?.some((role) => user.userRoles.map((r) => r.roleId).includes(role)));
  }
}
